import UtilityHelper from "../service/utilities/UtilityHelper";

const companyCode: string = UtilityHelper.getUrlCompanyCode();

const StorageKeys = {
  api_token: `${companyCode}_api_token`,
  language: `${companyCode}_language`,
  refresh_token: `${companyCode}_refresh_token`,
  device_type: `${companyCode}_device_type`,
  device_id: `${companyCode}_device_id`,
  device_token: `${companyCode}_device_token`,
  launch_status: `${companyCode}_launch_status`,
  company_app_base_url: `${companyCode}_company_app_base_url`,
  web_app_config: `${companyCode}_web_app_config`,
  web_app_config_default: `${companyCode}_web_app_config_default`,
  web_ip_info: `${companyCode}_web_ip_info`,
  app_id: `${companyCode}_app_id`,
  company_default_theme: `${companyCode}_company_default_theme`,
  company_id: `${companyCode}_company_id`,
  account_id: `${companyCode}_account_id`,
  name: `${companyCode}_name`,
  logo: `${companyCode}_logo`,
  status: `${companyCode}_status`,
  public_key: `${companyCode}_public_key`,
  private_key: `${companyCode}_private_key`,
  login_status: `${companyCode}_login_status`,
  branch_id: `${companyCode}_branch_id`,
  branch_name: `${companyCode}_branch_name`,
  branch_logo: `${companyCode}_branch_logo`,
  home_branch_detail: `${companyCode}_home_branch_detail`,
  home_chat_badge_counter: `${companyCode}_home_chat_badge_counter`,
  home_notice_badge_counter: `${companyCode}_home_notice_badge_counter`,
  home_branch_product_url: `${companyCode}_home_branch_product_url`,
  home_notices: `${companyCode}_home_notices`,
  notices_detail: `${companyCode}_notices_detail`,
  preview_image_document: `${companyCode}_preview_image_document`,
  recover_password_detail: `${companyCode}_recover_password_detail`,
  settings_personal_info_email: `${companyCode}_settings_personal_info_email`,
  settings_personal_info_phone_number: `${companyCode}_settings_personal_info_phone_number`,
  settings_verification_change_email_value: `${companyCode}_settings_change_email_value`,
  settings_verification_change_phone_value: `${companyCode}_settings_change_phone_value`,
  settings_verification_detail: `${companyCode}_settings_verification_detail`,
  settings_verification_type: `${companyCode}_settings_verification_type`,
  signup_verification_detail: `${companyCode}_signup_verification_detail`,
  signup_third_party_connect_detail: `${companyCode}_signup_third_party_connect_detail`,
  guest_status: `${companyCode}_guest_status`,

  chats_chat_list: `${companyCode}_chats_chat_list`,
  chats_chat_selected: `${companyCode}_chats_chat_selected`,
  chats_symetric_key: `${companyCode}_chats_symetric_key`,
  chats_conversation_detail: `${companyCode}_chats_conversation_detail`,
  chats_popup_connect: `${companyCode}_chats_popup_connect`,

  verification_type: `${companyCode}_verification_type`,

  division_id: `${companyCode}_division_id`,
  division_title: `${companyCode}_division_title`,

  branch_detail_boarding: `${companyCode}_branch_detail_boarding`,
};

export default StorageKeys;
